import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { locale } from "primereact/api";
import { QueryClientProvider } from "react-query";
import App from "./App";
import { queryClient } from "./api/query";
import katex from "katex";

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "react-quill/dist/quill.snow.css";
import "./style/global.css";
import "katex/dist/katex.min.css";

// @ts-ignore
window.katex = katex;

locale("en");

const root = createRoot(document.getElementById("root")!);

root.render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
